module.exports = __webpack_public_path__ + "img/video-4-tmb.b8c8992e.png";